<template>
  <NavPage></NavPage>

  <!-- page head section starts -->
  <section class="page-head-section">
    <div class="container page-heading">
      <h2 class="h3 mb-3 text-white text-center">{{ $t("login") }}</h2>
      <nav aria-label="breadcrumb">
        <ol
          class="breadcrumb flex-lg-nowrap justify-content-center justify-content-lg-star"
        >
          <li class="breadcrumb-item">
            <a href="index.html"><i class="ri-home-line"></i>{{ $t("home") }}</a>
          </li>
          <li class="breadcrumb-item active" aria-current="page">{{ $t("login") }}</li>
        </ol>
      </nav>
    </div>
  </section>
  <!-- page head section end -->

  <!-- signin page start -->
  <section class="login-hero-section section-b-space">
    <div class="container">
      <div class="row">
        <div class="col-xl-5 col-lg-6 col-md-10 m-auto">
          <div class="login-data">
            <form class="auth-form" @submit.prevent="Login">
              <h2 class="mb-3">{{ $t("sign in") }}</h2>
              <div class="form-input">
                <input
                  v-model="phone"
                  type="tel"
                  class="form-control"
                  :placeholder="$t('enter your phone')"
                  required
                />
                <i class="ri-phone-line"></i>
              </div>

              <div class="form-input">
                <input
                  v-model="password"
                  type="password"
                  class="form-control"
                  :placeholder="$t('enter your password')"
                  required
                />
                <i class="ri-lock-password-line"></i>
              </div>

              <button
                type="submit"
                class="btn theme-btn submit-btn w-100 rounded-2"
                :disabled="isLoading"
              >
                <span v-if="isLoading">{{ $t("loading...") }}</span>
                <span v-else>{{ $t("continue") }}</span>
              </button>

              <p class="fw-normal content-color">
                {{ $t("By creating an account, I accept the") }}
                <span class="fw-semibold">{{
                  $t("Terms & Conditions & Privacy Policy")
                }}</span>
              </p>

              <p v-if="error" class="text-danger mt-2">{{ error }}</p>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- signin page end -->
</template>
<script setup>
import { ref } from "vue";
import axios from "@/api";
import NavPage from "../navigation/NavPage.vue";
// import FooterBarPage from "../layout/FooterBarPage.vue";
import { LOCAL_STORAGE_KEYS } from "@/utils/constants";

const phone = ref("");
const password = ref("");
const error = ref("");
const isLoading = ref(false);

const Login = async () => {
  error.value = "";
  isLoading.value = true;

  try {
    const response = await axios.post("delivery/login", {
      phone: phone.value,
      password: password.value,
    });

    console.log("Login response:", response);

    if (response.data?.token) {
      // Use the constant for token key
      localStorage.setItem(LOCAL_STORAGE_KEYS.AUTH_TOKEN_KEY, response.data.token);
      localStorage.setItem(
        LOCAL_STORAGE_KEYS.AUTH_USER_INFO,
        JSON.stringify(response.data.user)
      );
      axios.defaults.headers.common["Authorization"] = `Bearer ${response.data.token}`;

      // Force reload to ensure all app state is reset
      window.location.href = "/home";

      // Alternative SPA navigation (if you prefer no reload)
    } else {
      error.value = "Invalid response from server - no token received";
    }
  } catch (err) {
    console.error("Login error:", err);
    error.value =
      err.response?.data?.message ||
      err.response?.data?.error ||
      "Invalid credentials or server error";

    // Specific error for network issues
    if (err.code === "ERR_NETWORK") {
      error.value = "Network error - please check your connection";
    }
  } finally {
    isLoading.value = false;
  }
};
</script>
